import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useUnitConverter from '@di-shared/utils/useUnitConverter';

function DiagOdometerSkeleton() {
  const {t} = useInferableTranslation();
  const {defaultDistanceSymbol} = useUnitConverter();
  return (
    <section className="section section_driving_distance">
      <div className="section_container_header skeleton">
        <h2 className="title_xsmall_b">{t('T10052')}</h2>
      </div>
      <div className="section_container skeleton">
        <strong className="driving_distance_title">
          <span className="driving_distance_value">32,234</span>
          <span className="driving_distance_unit">{defaultDistanceSymbol}</span>
          <span className="ic ic_edit_20px" />
        </strong>
        <p className="driving_distance_desc">{t('T10150')}</p>
        <button
          className="section_container_full_btn"
          type="button"
        >
          <span className="blind">{t('T10151')}</span>
        </button>
      </div>
    </section>
  );
}

export default DiagOdometerSkeleton;
